<template>
  <div class="calculator">
    <transition name="fade">
      <div class="tutorial" v-if="tutorial" @click="closetutorial">
        <div
          class="maru"
          :style="{ top: charatop + 'px', left: charaleft + 'px' }"
        >
          <img src="/static/img/kokosuki2.png" />
        </div>
        <div
          class="maru2"
          :style="{ top: calctop + 'px', left: calcleft + 'px' }"
        >
          <img src="/static/img/kokosuki3.png" />
        </div>
      </div>
    </transition>
    <div class="attackdamage f">
      <div
        class="character"
        :style="{
          'background-image': 'url(\'/static/img/bg/' + rarity + '.png\')',
        }"
      >
        <div
          ref="charabg"
          class="chara_bg"
          :style="[
            charaname
              ? {
                  'background-image':
                    'url(\'/static/img/sd/' + charaname + '.png\')',
                }
              : '',
          ]"
          @click="showCharacterList"
          :title="charaname"
        ></div>
        <div class="status">
          <div class="list">
            <img src="/static/img/status/hp.png" title="health" />
            <p>
              {{ health
              }}<span v-if="calc_health > 0"> + {{ calc_health }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/armor.png" title="armor" />
            <p>{{ armor }}</p>
          </div>
          <div class="list">
            <img src="/static/img/status/reload.png" title="reload" />
            <p>
              {{ reload }}<span v-if="ac_reload > 0"> + {{ ac_reload }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/firepower.png" title="firepower" />
            <p>
              {{ firepower
              }}<span v-if="calc_firepower > 0"> + {{ calc_firepower }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/torpedo.png" title="torpedo" />
            <p>
              {{ torpedo
              }}<span v-if="calc_torpedo > 0"> + {{ calc_torpedo }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/evasion.png" title="evasion" />
            <p>
              {{ evasion
              }}<span v-if="calc_evasion"> + {{ calc_evasion }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/anti_air.png" title="anti_air" />
            <p>
              {{ anti_air
              }}<span v-if="calc_antiair > 0"> + {{ calc_antiair }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/aviation.png" title="aviation" />
            <p>
              {{ aviation
              }}<span v-if="Slot1.Aviation"> + {{ Slot1.Aviation }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/accuracy.png" title="accuracy" />
            <p>
              {{ accuracy }}
              <span v-if="calc_accuracy > 0"> + {{ calc_accuracy }}</span>
            </p>
          </div>
          <div class="list">
            <img src="/static/img/status/luck.png" title="luck" />
            <p>{{ luck }}</p>
          </div>
          <div class="list">
            <img src="/static/img/status/anti_sub.png" title="anti_sub" />
            <p>{{ anti_sub }}</p>
          </div>
          <div class="list">
            <img src="/static/img/status/oil.png" title="oil" />
            <p>{{ oil }}</p>
          </div>
        </div>
      </div>
      <div class="equip_field" ref="power">
        <ul>
          <li
            class="image"
            @click="equipSlot('Slot1')"
            :title="Slot1.Name"
            :style="[
              Slot1.Name
                ? {
                    'background-image':
                      'url(\'/static/img/weapons/' + Slot1.Bg + '.png\')',
                  }
                : {
                    'background-image': 'url(\'/static/img/bg/weapon_bg.png\')',
                  },
            ]"
          >
            <div
              class="image"
              :style="[
                Slot1.Name
                  ? {
                      'background-image':
                        'url(\'/static/img/weapons/' + Slot1.Name + '.png\')',
                    }
                  : {
                      'background-image': 'none',
                    },
              ]"
            />
          </li>
          <li class="equip_status">
            <div class="estat">
              <p>砲撃時間</p>
              <p>{{ Slot1.VT }}s</p>
            </div>
            <div class="estat">
              <p>対軽装甲</p>
              <p>{{ Slot1.軽装甲 }}%</p>
            </div>
            <div class="estat">
              <p>対中装甲</p>
              <p>{{ Slot1.中装甲 }}%</p>
            </div>
            <div class="estat">
              <p>対重装甲</p>
              <p>{{ Slot1.重装甲 }}%</p>
            </div>
            <div class="estat">
              <p>攻撃速度</p>
              <p>{{ Slot1.Reload }}s</p>
            </div>
          </li>
        </ul>
        <ul>
          <li
            class="image"
            @click="equipSlot('Slot2')"
            :title="Slot2.Name"
            :style="[
              Slot2.Name
                ? {
                    'background-image':
                      'url(\'/static/img/weapons/' + Slot2.Bg + '.png\')',
                  }
                : {
                    'background-image': 'url(\'/static/img/bg/weapon_bg.png\')',
                  },
            ]"
          >
            <div
              class="image"
              :style="[
                Slot2.Name
                  ? {
                      'background-image':
                        'url(\'/static/img/weapons/' + Slot2.Name + '.png\')',
                    }
                  : {
                      'background-image': 'none',
                    },
              ]"
            />
          </li>
          <li
            class="image"
            @click="equipSlot('Slot3')"
            :title="Slot3.Name"
            :style="[
              Slot3.Name
                ? {
                    'background-image':
                      'url(\'/static/img/weapons/' + Slot3.Bg + '.png\')',
                  }
                : {
                    'background-image': 'url(\'/static/img/bg/weapon_bg.png\')',
                  },
            ]"
          >
            <div
              class="image"
              :style="[
                Slot3.Name
                  ? {
                      'background-image':
                        'url(\'/static/img/weapons/' + Slot3.Name + '.png\')',
                    }
                  : {
                      'background-image': 'none',
                    },
              ]"
            />
          </li>
          <li
            class="image"
            @click="equipSlot('Slot4')"
            :title="Slot4.Name"
            :style="[
              Slot4.Name
                ? {
                    'background-image':
                      'url(\'/static/img/weapons/' + Slot4.Bg + '.png\')',
                  }
                : {
                    'background-image': 'url(\'/static/img/bg/weapon_bg.png\')',
                  },
            ]"
          >
            <div
              class="image"
              :style="[
                Slot4.Name
                  ? {
                      'background-image':
                        'url(\'/static/img/weapons/' + Slot4.Name + '.png\')',
                    }
                  : {
                      'background-image': 'none',
                    },
              ]"
            />
          </li>
          <li
            class="image"
            @click="equipSlot('Slot5')"
            :title="Slot5.Name"
            :style="[
              Slot5.Name
                ? {
                    'background-image':
                      'url(\'/static/img/weapons/' + Slot5.Bg + '.png\')',
                  }
                : {
                    'background-image': 'url(\'/static/img/bg/weapon_bg.png\')',
                  },
            ]"
          >
            <div
              class="image"
              :style="[
                Slot5.Name
                  ? {
                      'background-image':
                        'url(\'/static/img/weapons/' + Slot5.Name + '.png\')',
                    }
                  : {
                      'background-image': 'none',
                    },
              ]"
            />
          </li>
        </ul>
      </div>
      <transition name="change" mode="out-in">
        <div class="calc_field m" v-if="switch_btn" key="damage">
          <div class="list">
            <label>装備威力</label>
            <input
              type="number"
              maxlength="4"
              name="equip_power"
              v-model="equip_power"
            />
          </div>
          <div class="list">
            <label>砲補正(%)</label>
            <input
              type="number"
              maxlength="4"
              name="cannon_efficiency"
              v-model="cannon_efficiency"
            />
          </div>
          <div class="list">
            <label>装備補正(%)</label>
            <input
              type="number"
              maxlength="4"
              name="equip_efficiency"
              v-model="equip_efficiency"
              readonly
            />
          </div>
          <div class="list">
            <label>火力値</label>
            <input
              type="number"
              maxlength="4"
              name="firepower"
              v-model="ac_firepower"
              readonly
            />
          </div>
          <div class="list">
            <label>火力値バフ(%)</label>
            <input
              type="number"
              maxlength="4"
              name="status_buff"
              v-model="status_buff"
            />
          </div>
          <div class="list">
            <label>装甲補正(%)</label>
            <input
              type="number"
              maxlength="4"
              name="armor_efficiency"
              v-model="armor_efficiency"
            />
          </div>
          <div class="list">
            <label>レベル差補正</label>
            <input type="number" maxlength="4" name="level" v-model="level" />
          </div>
          <div class="list">
            <label>与ダメ補正</label>
            <input
              type="number"
              maxlength="4"
              name="damage_efficiency"
              v-model="damage_efficiency"
            />
          </div>
          <div class="list">
            <label>実砲撃間隔</label>
            <input
              type="text"
              name="calc_reload"
              v-model="calc_reload"
              readonly
            />
          </div>
          <div class="list">
            <label>DPS</label>
            <input
              type="number"
              name="damage_result"
              v-model="damage_result"
              readonly
            />
          </div>
        </div>
        <div class="calc_field m" v-else key="evasion">
          <div class="list">
            <label>攻撃側命中値</label>
            <input
              type="number"
              maxlength="4"
              name="attackside_accuracy"
              v-model="attackside_accuracy"
              readonly
            />
          </div>
          <div class="list">
            <label>防衛側回避値</label>
            <input
              type="number"
              maxlength="4"
              name="defenceside_evasion"
              v-model="defenceside_evasion"
            />
          </div>
          <div class="list">
            <label>攻撃側幸運値</label>
            <input
              type="number"
              maxlength="4"
              name="attackside_luck"
              v-model="attackside_luck"
              readonly
            />
          </div>
          <div class="list">
            <label>防衛側幸運値</label>
            <input
              type="number"
              maxlength="4"
              name="defenceside_luck"
              v-model="defenceside_luck"
            />
          </div>
          <div class="list">
            <label>回避値バフ(%)</label>
            <input
              type="number"
              maxlength="4"
              name="evasion_buff"
              v-model="evasion_buff"
            />
          </div>
          <div class="list">
            <label>回避率バフ</label>
            <input
              type="number"
              maxlength="4"
              name="evasionrate_buff"
              v-model="evasionrate_buff"
            />
          </div>
          <div class="list">
            <label>実質耐久値</label>
            <input
              type="number"
              maxlength="4"
              name="totalhp"
              v-model="totalhp"
            />
          </div>
          <div class="list">
            <label>防衛側命中値</label>
            <input
              type="number"
              maxlength="4"
              name="enemy_accuracy"
              v-model="enemy_accuracy"
            />
          </div>
          <div class="list">
            <label>回避率</label>
            <input
              maxlength="4"
              name="evationrate"
              v-model="evationrate"
              readonly
            />
          </div>
          <div class="list">
            <label>命中率</label>
            <input
              maxlength="4"
              name="accuracyrate"
              v-model="accuracyrate"
              readonly
            />
          </div>
        </div>
      </transition>
    </div>
    <div
      class="switch_btn"
      @click="switched()"
      :style="[
        switch_btn
          ? {
              filter: 'hue-rotate(90deg)',
              transform: 'rotate(360deg)',
            }
          : '',
      ]"
    >
      <img src="/static/img/switch_btn.png" alt="切り替え" />
    </div>
    <div class="note">
      <p>計算式は英wikiだったり日wikiだったりを参考</p>
      <p>スマホ対応は雑にしてるPCで開け</p>
      <p>全弾発射も砲座+2も考慮してないガバガバ計算</p>
      <p>超詳しく知りたいなら大陸勢が表作ってるからそっち見ろ</p>
      <p>KANSENの装填値込でのDPS…のはず</p>
      <p>KANSENのステータスはLv120未結婚好感度100の状態</p>
      <p>装備は＋10想定</p>
      <p>実砲撃間隔：砲撃時間＋艦種固定CD＋実攻撃速度</p>
      <p>
        防衛側回避値、防衛側幸運値、防衛側命中値の初期値は13章の大鳳がこんなステらしいから入れてる
      </p>
      <p>
        <span style="color: #ea5550; font-weight: bold">注意！</span
        >：構えと砲撃時間は駆逐砲は駆逐艦、軽巡砲は軽巡洋艦が装備する前提
      </p>
      <p>
        <span style="color: #ea5550; font-weight: bold">注意！</span
        >：ニーミちゃんに軽巡砲とかは考慮してない
      </p>
    </div>
    <transition name="slide-fade">
      <List
        v-show="showList"
        @selected="inputStatus"
        @close="showCharacterList"
      ></List>
    </transition>
    <transition name="slide-fade">
      <Weapons
        :type="give"
        v-show="showWeapons"
        @selected="inputWeapons"
        @close="showWeaponsList"
        ref="weap"
      ></Weapons>
    </transition>
  </div>
</template>

<script>
import List from "./List";
import Weapons from "./Weapons";
export default {
  name: "Calc",
  components: { List, Weapons },
  data() {
    return {
      charatop: 0,
      charaleft: 0,
      calctop: 0,
      calcleft: 0,
      switch_btn: true,
      tutorial: true,
      showList: false,
      showWeapons: false,
      charaname: "",
      shiptype: "",
      health: 0,
      ahealth: 0,
      armor: "",
      reload: 0,
      firepower: 0,
      torpedo: 0,
      evasion: 0,
      anti_air: 0,
      aviation: 0,
      accuracy: 0,
      luck: 0,
      anti_sub: 0,
      oil: 0,
      rarity: "SSR",
      equip_power: 0,
      cannon_efficiency: 100,
      equip_efficiency: 100,
      status_buff: 0,
      armor_efficiency: 100,
      level: 0,
      damage_efficiency: 0,
      defenceside_evasion: 75,
      defenceside_luck: 25,
      evasion_buff: 0,
      evasionrate_buff: 0,
      level2: 0,
      enemy_accuracy: 70,
      Slot1type: "",
      Slot2type: "",
      Slot3type: "",
      Slot4type: "",
      Slot5type: "",
      Slot1: "",
      Slot2: "",
      Slot3: "",
      Slot4: "",
      Slot5: "",
      setSlot: "",
      give: [""],
    };
  },
  mounted() {
    const dom = this.$refs.charabg;
    const rect = dom.getBoundingClientRect();
    this.charatop = rect.top + 30;
    this.charaleft = rect.left - 120;
    this.calctop = rect.bottom + 220;
    this.calcleft = rect.right - 60;
  },
  methods: {
    switched: function () {
      if (this.switch_btn) {
        this.switch_btn = false;
      } else {
        this.switch_btn = true;
      }
    },
    closetutorial: function () {
      this.tutorial = false;
    },
    showCharacterList: function () {
      if (this.showList) {
        this.showList = false;
      } else {
        this.showList = true;
      }
    },
    showWeaponsList: function () {
      if (this.showWeapons) {
        this.showWeapons = false;
      } else {
        this.showWeapons = true;
      }
    },
    inputStatus: function (data) {
      this.charaname = data.Name;
      this.shiptype = data.Type;
      this.health = data.Health;
      this.armor = data.Armor;
      this.reload = data.Reload;
      this.firepower = data.Firepower;
      this.torpedo = data.Torpedo;
      this.evasion = data.Evasion;
      this.anti_air = data.Anti_Air;
      this.aviation = data.Aviation;
      this.accuracy = data.Accuracy;
      this.luck = data.Luck;
      this.anti_sub = data.Anti_Sub;
      this.oil = data.Oil;
      this.rarity = data.Rarity;
      if (data.Slot1.Efficiency != null) {
        this.equip_efficiency = data.Slot1.Efficiency;
      }
      this.Slot1type = data.Slot1.Type;
      this.Slot2type = data.Slot2.Type;
      this.Slot3type = data.Slot3.Type;
      this.Slot4type = data.Slot4.Type;
      this.Slot5type = data.Slot5.Type;
      this.Slot1 = "";
      this.Slot2 = "";
      this.Slot3 = "";
      this.Slot4 = "";
      this.Slot5 = "";
      this.showList = false;
    },
    inputWeapons: function (data) {
      if (data == "back") {
        switch (this.setSlot) {
          case "Slot1":
            this.Slot1 = "";
            break;
          case "Slot2":
            this.Slot2 = "";
            break;
          case "Slot3":
            this.Slot3 = "";
            break;
          case "Slot4":
            this.Slot4 = "";
            break;
          case "Slot5":
            this.Slot5 = "";
            break;
        }
        this.showWeaponsList();
        return false;
      }
      switch (this.setSlot) {
        case "Slot1":
          this.Slot1 = data;
          break;
        case "Slot2":
          this.Slot2 = data;
          break;
        case "Slot3":
          this.Slot3 = data;
          break;
        case "Slot4":
          this.Slot4 = data;
          break;
        case "Slot5":
          this.Slot5 = data;
          break;
      }
      this.equip_power = this.Slot1.Damage;
      this.cannon_efficiency = this.Slot1.CE;
      this.showWeaponsList();
    },
    equipSlot: function (slot) {
      this.setSlot = slot;
      switch (slot) {
        case "Slot1":
          this.give.splice(0, 1, this.Slot1type);
          break;
        case "Slot2":
          this.give.splice(0, 1, this.Slot2type);
          break;
        case "Slot3":
          this.give.splice(0, 1, this.Slot3type);
          break;
        case "Slot4":
          this.give.splice(0, 1, this.Slot4type);
          break;
        case "Slot5":
          this.give.splice(0, 1, this.Slot5type);
          break;
      }
      this.showWeaponsList();
    },
  },
  computed: {
    totalhp: function () {
      if (!this.health) {
        return 0;
      }
      let result =
        (parseInt(this.calc_health, 10) + parseInt(this.health, 10)) /
        (1 - parseInt(this.evationrate, 10) / 100);
      return Math.round(result);
    },
    calc_health: function () {
      let totalhealth = 0;
      if (this.Slot1.Health) {
        totalhealth = totalhealth + this.Slot1.Health;
      }
      if (this.Slot2.Health) {
        totalhealth = totalhealth + this.Slot2.Health;
      }
      if (this.Slot3.Health) {
        totalhealth = totalhealth + this.Slot3.Health;
      }
      if (this.Slot4.Health) {
        totalhealth = totalhealth + this.Slot4.Health;
      }
      if (this.Slot5.Health) {
        totalhealth = totalhealth + this.Slot5.Health;
      }
      return totalhealth;
    },
    calc_firepower: function () {
      let totalfirepower = 0;
      if (this.Slot1.Firepower) {
        totalfirepower = totalfirepower + this.Slot1.Firepower;
      }
      if (this.Slot2.Firepower) {
        totalfirepower = totalfirepower + this.Slot2.Firepower;
      }
      if (this.Slot3.Firepower) {
        totalfirepower = totalfirepower + this.Slot3.Firepower;
      }
      if (this.Slot4.Firepower) {
        totalfirepower = totalfirepower + this.Slot4.Firepower;
      }
      if (this.Slot5.Firepower) {
        totalfirepower = totalfirepower + this.Slot5.Firepower;
      }
      return totalfirepower;
    },
    calc_torpedo: function () {
      let totaltopedo = 0;
      if (this.Slot1.Torpedo) {
        totaltopedo = totaltopedo + this.Slot1.Torpedo;
      }
      if (this.Slot2.Torpedo) {
        totaltopedo = totaltopedo + this.Slot2.Torpedo;
      }
      if (this.Slot3.Torpedo) {
        totaltopedo = totaltopedo + this.Slot3.Torpedo;
      }
      if (this.Slot4.Torpedo) {
        totaltopedo = totaltopedo + this.Slot4.Torpedo;
      }
      if (this.Slot5.Torpedo) {
        totaltopedo = totaltopedo + this.Slot5.Torpedo;
      }
      return totaltopedo;
    },
    calc_antiair: function () {
      let totalantiair = 0;
      if (this.Slot1.Anti_air) {
        totalantiair = totalantiair + this.Slot1.Anti_air;
      }
      if (this.Slot2.Anti_air) {
        totalantiair = totalantiair + this.Slot2.Anti_air;
      }
      if (this.Slot3.Anti_air) {
        totalantiair = totalantiair + this.Slot3.Anti_air;
      }
      if (this.Slot4.Anti_air) {
        totalantiair = totalantiair + this.Slot4.Anti_air;
      }
      if (this.Slot5.Anti_air) {
        totalantiair = totalantiair + this.Slot5.Anti_air;
      }
      return totalantiair;
    },
    calc_evasion: function () {
      let totalevasion = 0;
      if (this.Slot1.Evasion) {
        totalevasion = totalevasion + this.Slot1.Evasion;
      }
      if (this.Slot2.Evasion) {
        totalevasion = totalevasion + this.Slot2.Evasion;
      }
      if (this.Slot3.Evasion) {
        totalevasion = totalevasion + this.Slot3.Evasion;
      }
      if (this.Slot4.Evasion) {
        totalevasion = totalevasion + this.Slot4.Evasion;
      }
      if (this.Slot5.Evasion) {
        totalevasion = totalevasion + this.Slot5.Evasion;
      }
      return totalevasion;
    },
    ac_reload: function () {
      let totalreload = 0;
      if (this.Slot1.reload) {
        totalreload = totalreload + this.Slot1.reload;
      }
      if (this.Slot2.reload) {
        totalreload = totalreload + this.Slot2.reload;
      }
      if (this.Slot3.reload) {
        totalreload = totalreload + this.Slot3.reload;
      }
      if (this.Slot4.reload) {
        totalreload = totalreload + this.Slot4.reload;
      }
      if (this.Slot5.reload) {
        totalreload = totalreload + this.Slot5.reload;
      }
      return totalreload;
    },
    calc_accuracy: function () {
      let totalaccuracy = 0;
      if (this.Slot1.Accuracy) {
        totalaccuracy = totalaccuracy + this.Slot1.Accuracy;
      }
      if (this.Slot2.Accuracy) {
        totalaccuracy = totalaccuracy + this.Slot2.Accuracy;
      }
      if (this.Slot3.Accuracy) {
        totalaccuracy = totalaccuracy + this.Slot3.Accuracy;
      }
      if (this.Slot4.Accuracy) {
        totalaccuracy = totalaccuracy + this.Slot4.Accuracy;
      }
      if (this.Slot5.Accuracy) {
        totalaccuracy = totalaccuracy + this.Slot5.Accuracy;
      }
      return totalaccuracy;
    },
    ac_firepower: function () {
      if (this.status_buff > 0) {
        return Math.round(
          (this.firepower + this.calc_firepower) * (1 + this.status_buff / 100)
        );
      } else {
        return this.firepower + this.calc_firepower;
      }
    },
    calc_reload: function () {
      let CRELOAD = 0;
      let VT = this.Slot1.VT;
      let AC = 0;
      switch (this.shiptype) {
        case "駆逐":
          AC = 0.26;
          break;
        case "軽巡":
          AC = 0.28;
          break;
        case "重巡":
          AC = 0.3;
          break;
        default:
          AC = 0;
          break;
      }
      CRELOAD =
        Math.round(
          this.Slot1.Reload *
            Math.pow(200 / (this.reload + this.ac_reload + 100), 0.5) *
            100
        ) / 100;
      if (isNaN(CRELOAD)) {
        return 0;
      } else {
        return Math.round((CRELOAD + VT + AC) * 10) / 10 + "s";
      }
    },
    damage_result: function () {
      let DPS = 0;
      let DMG = 0;
      let AC = 0;
      if (this.Slot1.Name) {
        let VT = this.Slot1.VT;
        let RLD =
          Math.round(
            this.Slot1.Reload * Math.pow(200 / (this.reload + 100), 0.5) * 100
          ) / 100;
        let SHOT = this.Slot1.Shots;
        switch (this.shiptype) {
          case "駆逐":
            AC = 0.26;
            break;
          case "軽巡":
            AC = 0.28;
            break;
          case "重巡":
            AC = 0.3;
            break;
          default:
            AC = 0;
            break;
        }
        DMG = Math.ceil(
          this.equip_power *
            (this.cannon_efficiency / 100) *
            (this.equip_efficiency / 100) *
            ((100 +
              (this.firepower + this.calc_firepower) *
                (1 + this.status_buff / 100)) *
              0.01) *
            (this.armor_efficiency / 100) *
            (1 + this.level * 0.02) *
            (1 + this.damage_efficiency / 100)
        );
        DPS = (DMG * SHOT) / (RLD + VT + AC);
        return Math.round(DPS * 100) / 100;
      } else {
        DPS = 0;
        return DPS;
      }
    },
    attackside_accuracy: function () {
      return this.calc_accuracy + this.accuracy;
    },
    attackside_luck: function () {
      return this.luck;
    },
    evationrate: function () {
      let result =
        1 -
        (0.1 +
          parseInt(this.enemy_accuracy, 10) /
            (parseInt(this.enemy_accuracy, 10) +
              (parseInt(this.calc_evasion, 10) + parseInt(this.evasion, 10)) *
                (1 + parseInt(this.evasion_buff, 10) / 100) +
              2) +
          (parseInt(this.defenceside_luck, 10) -
            parseInt(this.attackside_luck) +
            parseInt(this.level2, 10)) /
            1000);
      result = Math.round(result * 1000) / 10 + parseInt(this.evasionrate_buff);

      if (result > 90) {
        result = 90;
      } else if (result < 10) {
        result = 10;
      }
      return result + "%";
    },
    accuracyrate: function () {
      let result =
        0.1 +
        parseInt(this.attackside_accuracy, 10) /
          (parseInt(this.attackside_accuracy, 10) +
            parseInt(this.defenceside_evasion, 10) +
            2) +
        (parseInt(this.attackside_luck, 10) -
          parseInt(this.defenceside_luck, 10)) /
          1000;
      result = Math.round(result * 1000) / 10;
      if (result > 90) {
        result = 90;
      } else if (result < 10) {
        result = 10;
      }
      return result + "%";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.switch_btn {
  width: 92px;
  position: fixed;
  right: 5%;
  bottom: 5%;
  transition: 0.3s;
}
.calculator {
  margin: 0 auto;
}
.attackdamage {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}
.character {
  position: relative;
  border: 2px #f0f0f0 inset;
  width: 100%;
  display: flex;
  justify-content: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.status {
  width: 400px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  div {
    width: calc(33.33% - 10px);
    padding: 3px 6px;
    margin: 2px;
    &.list {
      color: #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgba(50, 50, 50, 0.7);
      p {
        font-size: 110%;
        text-align: right;
        width: calc(100% - 23px);
        pointer-events: none;
        span {
          color: #00ff7f;
        }
      }
      img {
        width: auto;
        height: auto;
      }
    }
  }
}
.chara_bg {
  height: 152px;
  width: 152px;
  background-position: center center;
  background-repeat: no-repeat;
  filter: drop-shadow(-6px 1px rgba(80, 80, 80, 0.5));
  cursor: pointer;
}
.equip_field {
  padding: 8px 8px 3px 8px;
  background: rgba(50, 50, 50, 0.3);
  ul {
    display: flex;
    justify-content: space-between;
    background: rgba(50, 50, 50, 0.8);
    padding: 3px;
    li.image {
      overflow: hidden;
      position: relative;
      background-size: cover;
      border: 2px #f0f0f0 inset;
      width: 70px;
      height: 70px;
      padding: 3px;
      box-shadow: 5px 5px 1px rgba(50, 50, 50, 0.8);
      &::before {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: -75%;
        z-index: 2;
        display: block;
        content: "";
        width: 50%;
        height: 100%;
        background: -webkit-linear-gradient(
          left,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.3) 100%
        );
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.3) 100%
        );
        -webkit-transform: skewX(-25deg);
        transform: skewX(-25deg);
      }
      &:hover::before {
        -webkit-animation: shine 0.75s;
        animation: shine 0.75s;
      }
      .image {
        cursor: pointer;
        filter: drop-shadow(-3px 3px rgba(80, 80, 80, 0.7));
        width: 100%;
        height: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
    li.equip_status {
      width: calc(100% - 80px);
      margin-left: 10px;
      color: #f0f0f0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      .estat {
        p {
          height: 35px;
          padding: 3px;
          line-height: 35px;
          &:first-of-type {
            font-family: "moji";
            font-size: 90%;
          }
          &:last-of-type {
            background: rgba(30, 30, 30, 0.8);
          }
        }
      }
    }
  }
}
@keyframes shine {
  100% {
    left: 125%;
  }
}
.calc_field {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: rgba(50, 50, 50, 0.3);
  backdrop-filter: blur(4px);
  padding: 5px;
  input {
    font-size: 110%;
    font-family: "number";
    background: rgba(30, 30, 30, 0.8);
    width: 40%;
    padding: 4px 0;
  }
  .list {
    width: 48%;
    padding: 5px;
    margin: 3px;
    color: #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(50, 50, 50, 0.8);
    &:nth-last-of-type(2) {
      background: rgba(50, 150, 50, 0.8);
    }
    &:last-of-type {
      background: rgba(150, 50, 50, 0.8);
    }
    label {
      font-size: 90%;
      padding: 0 3px;
    }
  }
}
.tutorial {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: rgba(30, 30, 30, 0.3);
  .maru,
  .maru2 {
    position: absolute;
    width: 300px;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.note {
  text-align: left;
  padding: 5px 5px;
  color: #f0f0f0;
  font-size: 80%;
  line-height: 1.3;
  max-width: 600px;
  margin: 30px auto 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100vw);
  opacity: 0;
}
.change-enter-active {
  transition: all 0.2s ease;
}
.change-leave-active {
  transition: all 0.2s ease;
}
.change-enter,
.change-leave-to {
  transform: rotateY(180deg);
  opacity: 0;
}
@media screen and (max-width: 450px) {
  .switch_btn {
    right: 5%;
    bottom: 1%;
  }
  .chara_bg {
    width: 80px;
    height: auto;
    background-size: contain;
  }
  .status {
    width: calc(100% - 80px);
    div {
      width: 33.33%;
      margin: 1px 0;
      padding: 1px 2px;
      &.list {
        font-size: 90%;
        img {
          width: 23px;
        }
      }
      &.list:nth-of-type(2) {
        p {
          font-size: 85%;
          text-align: right;
          width: calc(100% - 25px);
          pointer-events: none;
        }
      }
    }
  }
  .equip_field {
    padding: 5px 0 5px 0;
    ul {
      li.image {
        width: 60px;
        height: 60px;
      }
      li.equip_status {
        margin-left: 5px;
        width: calc(100% - 70px);
        .estat {
          p {
            height: 30px;
            line-height: 30px;
          }
          p:first-of-type {
            font-size: 75%;
          }
        }
      }
    }
  }
  .calc_field {
    padding: 0;
    .list {
      font-size: 85%;
      padding: 1px;
    }
  }
  .tutorial {
    display: none;
    .maru,
    .maru2 {
      position: absolute;
      width: 300px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
